import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;
const masterPartnerUrl = env.REACT_APP_LSNG_MASTERPARTNER_API_URL;
const facilitiesURL = url + "/LeasingFacilities";

const getPartnersList = search => {
  return get(`${masterPartnerUrl}/Partners/partners?search=${search}`);
};

const getFacilityRevolvingTypes = () => get(`${facilitiesURL}/getFacilityRevolvingTypes`);
const getFacilityFlexibilityRules = () => get(`${facilitiesURL}/getFacilityFlexibilityRules`);
const getFacilityCreditLineStatuses = () => get(`${facilitiesURL}/getFacilityCreditLineStatuses`);
const getFacilityPurposesForApplication = () => get(`${facilitiesURL}/getFacilityPurposesForApplication`);
const getPartnerGroups = () => get(`${url}/partner-hierarchies`);
const getTransferToERPPermissions = (documentId, siteId) =>
  get(`${facilitiesURL}/${documentId}/${siteId}/transferfacilitydocumenttoERPpermissions`);

const saveFacilityHeader = (item, documentId, siteId) => {
  return post(`${facilitiesURL}/${documentId}/${siteId}/saveHeader`, {
    item: item,
    documentId: documentId,
    siteId: siteId
  });
};

const transferFacilityToERP = (documentId, siteId) => {
  return post(`${facilitiesURL}/${documentId}/${siteId}/transferfacilitydocumenttoERP`, {
    documentId: documentId,
    siteId: siteId
  });
};

const getFacilityWarranties = (documentId, siteId) => get(`${url}/leasingdocument/${documentId}/${siteId}/warranties`);

const exp = {
  getPartnersList,
  getFacilityRevolvingTypes,
  getFacilityFlexibilityRules,
  getFacilityCreditLineStatuses,
  getFacilityPurposesForApplication,
  getPartnerGroups,
  getTransferToERPPermissions,
  saveFacilityHeader,
  transferFacilityToERP,
  getFacilityWarranties
};
export default exp;
